import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import { useAuth } from "hooks/useAuth";

export const LoginPage = () => {
  const { login, challenge, verifyTwoFactor, cancelChallenge } = useAuth();
  const [useBackupCode, setUseBackupCode] = React.useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    login({
      username: data.get("username"),
      password: data.get("password"),
    });
  };

  const handleVerify = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    verifyTwoFactor({ code: data.get("code") });
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          {challenge ? "Two-Factor Authentication" : "Log In"}
        </Typography>

        {challenge ? (
          <Box
            key="two-factor-form"
            component="form"
            onSubmit={handleVerify}
            noValidate
            sx={{ mt: 1, width: "100%" }}
          >
            <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
              {useBackupCode
                ? "Enter one of your one-time backup codes."
                : "Enter the 6-digit code from your authenticator app."}
            </Typography>
            <TextField
              margin="normal"
              required
              fullWidth
              id="code"
              label={useBackupCode ? "Backup code" : "Authenticator code"}
              name="code"
              autoComplete="one-time-code"
              autoFocus
              inputProps={{ maxLength: useBackupCode ? 9 : 6 }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 1 }}
            >
              Verify
            </Button>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Link
                component="button"
                type="button"
                variant="body2"
                onClick={() => setUseBackupCode((v) => !v)}
              >
                {useBackupCode
                  ? "Use your authenticator app instead"
                  : "Use a backup code instead"}
              </Link>
              <Link
                component="button"
                type="button"
                variant="body2"
                onClick={cancelChallenge}
              >
                Back to login
              </Link>
            </Box>
          </Box>
        ) : (
          <Box
            key="credentials-form"
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
              autoComplete="username"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Login In
            </Button>
          </Box>
        )}
      </Box>
    </Container>
  );
};
